import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import AOS from 'aos';

@Component({
  selector: 'app-casestudies-cover',
  imports: [CommonModule, FormsModule, RouterModule],
  standalone: true,
  templateUrl: './casestudies-cover.component.html',
  styleUrl: './casestudies-cover.component.scss'
})
export class CasestudiesCoverComponent implements AfterViewInit {

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }
  nav(url: any) {
    this.router.navigateByUrl(url)
  }
  ngAfterViewInit() {
    setTimeout(() => {
        AOS.init();
        AOS.refresh();
    }, 1000);
  }

  cards = [
    // Add more cards as needed
    { navLink: "/kalpita-case-studies/ai-powered-recruitment-tool", url: '../../../../assets/resources/casestudies/ai-powered-recruitment-tool/banner.webp', description: 'Solving Legacy System Challenges with Kalpita Recruitment Tool', industry: 'Insurance' },
    { navLink: "/kalpita-case-studies/unified-system-insurance", url: '../../../../assets/resources/casestudies/unifiedsystem-insurance/unified-insurecover.webp', description: 'Unified System for Insurance: Enhancing Efficiency with Automated Billing', industry: 'Insurance' },
    { navLink: "/kalpita-case-studies/aidriven-insurance-application", url: '../../../../assets/resources/casestudies/aidriven-insurance/aidriven-Insurancecover.webp', description: 'AI-Driven Insurance Application Accelerator: Customer Onboarding platform', industry: 'Insurance' },
    { navLink: "/kalpita-case-studies/us-retirement-plan", url: '../../../../assets/resources/casestudies/retire-advisory/retire-cover.jpg', description: 'Innovative Solutions for Retirement Planning and Pricing Strategies', industry: 'Finance' },
    { navLink: "/kalpita-case-studies/unified-portal", url: '../../../../assets/resources/casestudies/unified-customer-engagement.webp', description: 'Unified Customer Engagement Portal for Insurance Domain -Enhancing Brand Consistency and Client Interaction', industry: 'Insurance' },
    { navLink: "/kalpita-case-studies/implemented-datamigration", url: '../../../../assets/resources/casestudies/data-migration.webp', description: 'Data Migration & Integrated Data Warehouse Implementation for Informed Business Decisions', industry: 'Finance' },
    { navLink: "/kalpita-case-studies/saas-launch", url: '../../../../assets/resources/casestudies/casestudy-one.webp', description: 'SaaS product to launch a fully functional end-to-end ecommerce store', industry: 'E-Commerce & Retail' },
    { navLink: "/kalpita-case-studies/smart-integration", url: '../../../../assets/resources/casestudies/casestudy-two.webp', description: 'Smart integration engine to centralize workflow with a secure corporate network to streamline communications', industry: 'Healthcare' },
    { navLink: "/kalpita-case-studies/organized-portal", url: '../../../../assets/resources/casestudies/casestudy-four.webp', description: 'Organized eCommerce portal with 3 roles of managed access and payment gateways.', industry: 'E-Commerce & Retail' },
    { navLink: "/kalpita-case-studies/custom-sharepoint", url: '../../../../assets/resources/casestudies/casestudy-six.webp', description: 'Custom-built SharePoint interface to drive the right employee engagement in the organization', industry: 'IT' },
    { navLink: "/kalpita-case-studies/guard-dog-page", url: '../../../../assets/resources/casestudies/casestudy-seven.webp', description: '100% web-based, ready to deploy & Easy-to-use alert-based cellular monitoring system', industry: 'IT' },
    { navLink: "/kalpita-case-studies/meet-business", url: '../../../../assets/resources/casestudies/casestudy-eight.webp', description: 'Meet your business goals with proven ERP methodologies at your fingertips.', industry: 'Enterprise' },
    { navLink: "/kalpita-case-studies/data-obfuscation", url: '../../../../assets/resources/casestudies/casestudy-nine.webp', description: 'Kalpita Data Obfuscation to improve data security', industry: 'IT' },
    { navLink: "/kalpita-case-studies/custom-web-development", url: '../../../../assets/resources/casestudies/web-development/cover-webdevCaseStudy.webp', description: 'End-to-end Custom Website Development for Cloud-Based Company', industry: 'Cloud' },
  ];
  ngOnInit(): void {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    );
    this.filterCards('All');
  }
  // Filtered cards to be displayed
  filteredCards = this.cards;
  selectedIndustry: string = 'All';

  // Method to filter cards based on selected industry
  filterCards(industry: string) {
    this.selectedIndustry = industry;
    if (industry === 'All') {
      this.filteredCards = this.cards;
    } else {
      this.filteredCards = this.cards.filter(card => card.industry === industry);
    }
  }
}
